import React from "react";

const BlockchainUrl = () => {
  return (
    <>
      <ul className="main-menu" id="top-menu-nav">
        {/* NFTs */}
        <li className="mega-sub-menu">
          <span>NFTs</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/nfts/development">
                    NFT Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/white-label-marketplace-development">
                    White-Label NFT Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/marketplace-development">
                    NFT Marketplace Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/ecosystem">
                    NFT Ecosystem
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/white-label-multi-chain-marketplace-development">
                    Whitelabel Multi chain NFT
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/white-label-launchpad-development">
                    White Label NFT Launchpad
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/launchpad-development">
                    NFT Launchpad Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/cross-chain-marketplace-development">
                    Cross-Chain NFT Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/exchange-development">
                    NFT Exchange Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/wallet-development">
                    NFT Wallet Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/minting-platform-development">
                    NFT Minting Platform Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/non-fungible-token-development">
                    NFT Token Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/dao-enabled-platform-development">
                    DAO Enabled NFT Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/marketplace-with-governance-token-development">
                    NFT Marketplace with Governance
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/celebrity-nft-marketplace-development">
                    Celebrity NFT Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/music-nft-marketplace-development">
                    NFT Marketplace for Music
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-art-marketplace-development">
                    NFT Marketplace for Artist
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/sports-nft-marketplace-development">
                    NFT Marketplace for Sports
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/physical-assets-marketplace-development">
                    NFT For Physical Assets
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/ticketing-marketplace-development">
                    NFT Ticketing Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/sft-development">
                    SFT Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-studio">
                    NFT Studio
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/aggregator-marketplace-development">
                    NFT Aggregator Marketplace Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/ethereum-nft-marketplace-development">
                    NFT Marketplace On Ethereum
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/polygon-nft-marketplace-development">
                    NFT Marketplace on Polygon
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/polygon-nft-marketplace-development">
                    NFT Marketplace on BSC
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/avalanche-nft-marketplace-development">
                    NFT Marketplace on Avalanche
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/sidechain-nft-marketplace-development">
                    NFT Development On Sidechain
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/solana-nft-marketplace-development">
                    NFT Marketplace On Solana
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/harmony-nft-marketplace-development">
                    NFT Marketplace On Harmony
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/harmony-nft-marketplace-development">
                    NFT Marketplace Like SuperRare
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/sudoswap-like-nft-marketplace-development">
                    NFT Marketplace like Sudoswap
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/sorare-like-nft-marketplace-development">
                    NFT Marketplace Like Sorare
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/opensea-like-nft-marketplace-development">
                    NFT Marketplace Like OpenSea
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/solsea-like-nft-marketplace-development">
                    NFT Marketplace like Solsea
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/rarible-like-nft-marketplace-development">
                    NFT Marketplace Like Rarible
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/layer-2-development">
                    NFT Layer2 Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/phygital-marketplace-development">
                    Phygital NFT Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/p2e-game-development">
                    P2E NFT Game Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-real-estate-marketplace-development">
                    NFT Marketplace for Real Estate
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-in-ecommerce">
                    NFT in E-commerce
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/gaming-platform-development">
                    NFT Gaming Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/dungeon-swap-like-nft-game-development">
                    Dungeon Swap Like NFT Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/my-crypto-heroes-like-nft-game-development">
                    My Crypto Heros Like NFT Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/zed-run-like-nft-game-development">
                    Zed Run Like NFT Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/decentraland-like-nft-game-development">
                    Decentraland Like NFT Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-racing-game-development">
                    NFT Racing Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/revv-racing-like-nft-game-development">
                    Revv Racing Like NFT Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/casino-game-development">
                    NFT Casino Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/nft-social-token-development">
                    NFT Social Token Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/staking-platform-development">
                    NFT Staking platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/streaming-platform-development">
                    NFT Streaming Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/consulting-service">
                    NFT Consulting Service
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/listing-services">
                    NFT Listing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/fractional-marketplace-development">
                    Fractional NFT Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/shards-nft-platform-development">
                    Shards NFT Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/white-label-p2e-game-development">
                    White Label P2E NFT Games
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/web2-to-web3-game-development">
                    Web2 To Web3 Game
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/gaming-marketplace-development">
                    NFT Game Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/nfts/move-to-earn-platform-development">
                    Move To Earn NFT Platform
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* EVM */}
        <li className="mega-sub-menu">
          <span>Ethereum Virtual Machine(EVM)</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/evm/token-bound-account-development">
                    Token Bound Account Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/account-abstraction-erc-4337-development">
                    Account Abstraction ERC 4337 Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/eip-7702-dapp-development">
                    EIP-7702 dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/erc-6551-dapp-development-services">
                    ERC-6551 dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/erc-4337-dapp-development-services">
                    ERC-4337 dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/zero-knowledge-proof-based-dapp-development-services">
                    Zero Knowledge Proof Based dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/post-quantum-ethereum-based-dapp-development-services">
                    Post Quantum Ethereum-Based dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/slh-dsa-based-post-quantum-secure-blockchain-development-services">
                    SLH DSA (Sphincs+) Based Post-Quantum Blockchain Development
                    Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/paymaster-smart-contract-development-services">
                    Paymaster Smart Contract Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/erc-8004-trustless-ai-agent-development-services">
                    ERC 8004 - Trustless AI Agents
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/evm/eth-interop-crosschain-development-services">
                    Ethereum Cross Chain Development Company
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Blockchain */}
        <li className="mega-sub-menu">
          <span>Blockchain</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-development-services">
                    Blockchain Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/white-label-blockchain-development-services">
                    White Label Blockchain Solutions
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/custom-blockchain-development-on-avalanche">
                    Custom Blockchain On Avalanche
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/custom-blockchain-development-on-polygon">
                    Custom Blockchain On Polygon
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/solana-blockchain-development">
                    Solana Blockchain Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-and-web3-consulting">
                    Blockchain and Web3.0 Consulting
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-proof-of-reserve">
                    Blockchain Proof Of Reserve
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/carbon-credits-development">
                    Carbon Credits Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-dapps-development">
                    Blockchain dApps Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-p2p-lending-software">
                    Blockchain P2P Lending Software
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-for-finance">
                    Blockchain for Finance
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-protocol-implementation">
                    Blockchain Protocol Implementation
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/blockchain-for-pharma-industry">
                    Blockchain for Pharma Industry
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/blockchain/evm-compatible-blockchain-and-service">
                    EVM Compatible Blockchain and Service
                  </a>
                </li>

                <li>
                  <a href="https://www.tanthetaa.com/blockchain/smart-contract-development">
                    Smart Contract Development
                  </a>
                </li>

                <li>
                  <a href="https://www.tanthetaa.com/blockchain/quantum-blockchain-development-services">
                    Quantum Blockchain Development
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Metaverse */}
        <li className="mega-sub-menu">
          <span>Metaverse</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/metaverse-development-company">
                    Metaverse Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/metaverse-nft-marketplace-development">
                    Metaverse NFT Marketplace Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/healthcare-solutions-development">
                    Metaverse Healthcare Solutions
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/nft-launchpad-development">
                    NFT Metaverse Launchpad Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/event-platform-development">
                    Metaverse Event Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/social-interaction-platform-development">
                    Metaverse Platform for Social Interaction
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/nft-game-development">
                    Metaverse NFT Game Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/art-gallery-development">
                    Metaverse Art Gallery
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/avatar-development">
                    Metaverse Avatar Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/3d-space-development">
                    Metaverse 3D Space Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/metaverse/virtual-working-space-development">
                    Metaverse Virtual Working Space
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Web 3.0 */}
        <li className="mega-sub-menu">
          <span>Web 3.0</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/web3/web3-development-services">
                    Web 3.0 Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/dapps-development-services">
                    Web3 dApp Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/wallet-development">
                    Web3 Wallet Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/game-development">
                    Web 3.0 Game Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/marketing-services">
                    Web 3.0 Marketing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/metamask-like-wallet-development">
                    Web3 Metamask Like Wallet Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/decentralized-multichain-wallet-like-backpack-evm-solana">
                    Decentralized Multichain Wallet Like Backpack Evm Solana
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/meme-coin-development">
                    Meme Coin Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/ai-ml-based-glasses-app-development">
                    AI/ML Based Glasses App Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/multi-signature-wallet-development-services">
                    Multi-Signature Wallet Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/farcaster-based-dapps-development">
                    Farcaster-Based dApps Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/cello-blockchain-based-dapps-development">
                    Cello Blockchain-Based dApps Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/bitcoin-layer2-smart-contract-development-services">
                    Bitcoin Layer2 Smart Contract Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/web3/decentralized-video-conference-app-solidity-blockchain">
                    Decentralized Video Conference App Development with Solidity
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Crypto */}
        <li className="mega-sub-menu">
          <span>Crypto</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/crypto/casino-game-development">
                    Crypto Casino Game Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/cryptocurrency-development">
                    Cryptocurrency Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/stable-coin-development">
                    Stable Coin Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/white-label-crypto-exchange">
                    White label Crypto Exchange
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/cryptocurrency-exchange-development">
                    Cryptocurrency Exchange Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/decentralized-exchange-development">
                    Decentralized Exchange Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/p2p-exchange-development">
                    Crypto P2P Exchange Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/crypto-wallet-development">
                    Crypto Wallet Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/crypto-payment-development">
                    Crypto-Payment Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/crypto-exchange-listing-services">
                    Crypto Exchange Listing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/cryptocurrency-exchange-like-wazirx">
                    Cryptocurrency Exchange Like Wazirx
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/cryptocurrency-exchange-like-binance">
                    Cryptocurrency Exchange Like Binance
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/crypto/cryptocurrency-exchange-like-coinbase">
                    Cryptocurrency Exchange Like Coinbase
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* DeFi */}
        <li className="mega-sub-menu">
          <span>DeFi</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/defi/white-label-crypto-trading-telegram-bot">
                    White-Label Crypto Trading Telegram Bot Solution
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/defi-development-services">
                    DeFi Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/pancakeswap-like-platform-development">
                    DeFi Platform Like Pancakeswap
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/dao-development">
                    DeFi DAO Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/white-label-swap-exchange-development">
                    Whitelabel Swap Exchange Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/pinksale-like-launchpad-development">
                    Pinksale Like Launchpad Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/staking-platform-development">
                    DeFi Staking Platform Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/yield-farming-development">
                    DeFi Yield Farming Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/marketing-services">
                    DeFi Marketing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/application-development">
                    DeFi Application Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/token-development">
                    DeFi Token Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/protocol-like-yearn-finance-development">
                    DeFi Protocol Development Like yearn finance
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/limit-order-automated-market-maker-trading-platform-development-services">
                    Limit Order Automated Market Maker Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/multichain-dex-development-services">
                    Multichain DEX Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/wallet-development">
                    DeFi Wallet Development Solution
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/synthetic-assets-development">
                    DeFi Synthetic Assets Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/crowd-funding-platform-development">
                    DeFi Crowdfunding platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/real-estate-platform-development">
                    DeFi Real Estate platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/dex-development">
                    DeFi Exchange Development Solution
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/uniswap-like-platform-development">
                    DeFi Platform Like Uniswap
                  </a>
                </li>

                <li>
                  <a href="https://www.tanthetaa.com/defi/telegram-trading-bot-development">
                    Telegram Trading Bot Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/smart-wallet-account-development-services">
                    Smart Wallet Account Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/analytics-dashboard-development-services">
                    Analytics Dashboard Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/on-chain-trading-app-development-services">
                    On-Chain Trading App Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/real-world-asset-tokenization-platform-development">
                    Real World Asset Tokenization dApp Development Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/defi/lending-and-borrowing-protocol-development">
                    Lending and Borrowing Protocol Development
                  </a>
                </li>

                <li>
                  <a href="https://www.tanthetaa.com/defi/cross-chain-swap-protocol-development">
                    Cross Chain Swap Protocol Development Services
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Generative AI */}
        <li className="mega-sub-menu">
          <span>Generative AI</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-agent-development-services">
                    AI Agent Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/generative-ai-development-services">
                    Generative AI Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/machine-learning-development-services">
                    Machine Learning Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-chatbot-development-services">
                    AI Chatbot Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/voice-ai-agent-system-services">
                    Voice AI Agent System
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/on-chain-ai-agent-marketplace-services">
                    On-chain AI Agent Marketplace
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-workflow-development-n8n-services">
                    AI Workflow Development using n8n
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/custom-ai-model-development-services">
                    Custom AI Model Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-data-analytics-insights-services">
                    AI Data Analytics & Insights
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-automation-solutions-services">
                    AI Automation Solutions
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/generative-ai-solutions-services">
                    Generative AI Solutions
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-saas-product-development-services">
                    AI SaaS Product Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-security-fraud-detection-services">
                    AI Security and Fraud Detection
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-personalization-engines-services">
                    AI Personalization Engines
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-api-integration-services">
                    AI API & Integration Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-consulting-strategy-services">
                    AI Consulting & Strategy
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/multi-agent-systems-development-services">
                    Multi-Agent Systems Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/on-premise-private-ai-deployment-services">
                    On-Premise and Private AI Deployment
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-powered-crm-systems-services">
                    AI-Powered CRM Systems
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-document-processing-ocr-nlp-services">
                    AI Document Processing (OCR + NLP)
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-recommendation-systems-services">
                    AI Recommendation Systems
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-agent-for-smart-contract-audit-services">
                    AI agent for smart contract audit
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ethereum-interop-layer-services">
                    Ethereum interop layer
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/eth-interop-crosschain-services">
                    Ethereum Cross Chain Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/decision-intelligence-platform-services">
                    Decision Intelligence Platform Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-search-knowledge-system-services">
                    AI Search & Knowledge System Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-model-training-finetuning-services">
                    AI Model Training & Fine-Tuning Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/vector-database-ai-services">
                    Vector Database AI Solutions Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-observability-monitoring-services">
                    AI Observability & Monitoring Systems Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/gpu-ai-compute-platform-services">
                    GPU-Based AI Compute Platform Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/llm-app-development-services">
                    LLM Application Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/decentralized-ai-agents-services">
                    Decentralized AI agents Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/tokenized-ai-development-services">
                    Tokenized AI Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-farm-management-software-development-services">
                    AI Farm Management Software Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-crop-disease-detection-software-development-services">
                    AI Crop Disease Detection Software Development Company
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ai/ai-crop-yield-prediction-software-development-services">
                    AI Crop Yield Prediction Software Development Company
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* ICO */}
        <li className="mega-sub-menu">
          <span>ICO</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/ico/ico-development">
                    ICO Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/marketing">
                    ICO Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/community-marketing">
                    ICO Community Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/telegram-marketing">
                    ICO Telegram Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/influencer-marketing">
                    ICO Influencer Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/ieo-development">
                    IEO Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/eto-development">
                    ETO Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/crowdfunding-platform">
                    ICO Crowdfunding Platform
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ico/youtube-influencer">
                    ICO Youtube Influencer
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* STO */}
        <li className="mega-sub-menu">
          <span>STO</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/sto/development">
                    STO Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/marketing">
                    STO Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/smart-contract-development">
                    STO Smart Contracts
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/real-estate-tokenization">
                    STO Real Estate Tokenization
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/asset-tokenization">
                    STO Asset Tokenization
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/art-tokenization">
                    STO Art Tokenization
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/sto/tokenization-platform-development">
                    STO Tokenization Platform Development
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* IDO */}
        <li className="mega-sub-menu">
          <span>IDO</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/ido/development">
                    IDO Development
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/marketing">
                    IDO Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/white-label-ido-launchpad">
                    White Label IDO Launchpad
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/ido-token-launchpad-development">
                    IDO Token Launchpad
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/ido-launchpad-development-on-bsc">
                    IDO Launchpad On BSC
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/ido-launchpad-development-on-ethereum">
                    IDO Launchpad On Ethereum
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/ido-launchpad-development-on-multichain">
                    IDO Launchpad In Multichain
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/ido-launchpad-development-on-polygon">
                    IDO Launchpad On Polygon
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/ido/igo-launchpad-development">
                    IGO Launchpad Development
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        {/* Marketing */}
        <li className="mega-sub-menu">
          <span>Marketing</span>
          <ul className="mega-submenu">
            <li className="has-subsubmenu">
              <ul className="mega-submenu1">
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft">
                    NFT Marketing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft-marketplace">
                    NFT Marketplace Marketing Services
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft-marketplace">
                    NFT Collectibles Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft-collectibles">
                    NFT Game Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft-telegram">
                    NFT Telegram Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/influencer">
                    Influencer Marketing Agency
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/nft-pr-and-media">
                    NFT PR and Media Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/discord">
                    Discord Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/discord-server-marketing">
                    Discord Server Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/discord-brand">
                    Discord Brand Marketing
                  </a>
                </li>
                <li>
                  <a href="https://www.tanthetaa.com/marketing/discord-game">
                    Discord Game Marketing
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default BlockchainUrl;
